import styled from 'styled-components'
import {
	GridContainer,
	GridControlExpandWrapperStyled,
	GridInfinityScrollStyled,
	GridRowColumnLIStyled,
	IconComponent,
} from 'LibNeo'

export const IconStyled = styled(IconComponent)`
	width: 32px;
	height: 32px;
	cursor: pointer;
`

export const GridWrapper = styled(GridContainer)`
	${GridRowColumnLIStyled} {
		overflow: unset;
	}
	${GridControlExpandWrapperStyled} {
		display: none;
	}
`

export const SubGridWrapper = styled(GridContainer)`
	${GridInfinityScrollStyled} {
		overflow: hidden;
	}
`

export const WrapperStatus = styled.div`
	text-align: center;
	cursor: pointer;
`

export const BlockButtons = styled.div`
	display: flex;
`
